import { api } from './api';
import { Proposta, PropostaFormData, PropostasResponse } from '../types/proposta';
import { toast } from 'react-toastify';

export class PropostaService {
  static async listar(page = 1, limit = 10, search = ''): Promise<PropostasResponse> {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.append('search', search);
    const response = await api.get<PropostasResponse>(`/propostas?${params.toString()}`);
    return response as unknown as PropostasResponse;
  }

  static async buscarPorId(id: number): Promise<Proposta> {
    const response = await api.get<{ success: boolean; data: Proposta }>(`/propostas/${id}`);
    return (response as any).data;
  }

  static async criar(data: PropostaFormData): Promise<Proposta> {
    const response = await api.post<{ success: boolean; data: Proposta }>('/propostas', data);
    return (response as any).data;
  }

  static async atualizar(id: number, data: PropostaFormData): Promise<Proposta> {
    const response = await api.put<{ success: boolean; data: Proposta }>(`/propostas/${id}`, data);
    return (response as any).data;
  }

  static async excluir(id: number): Promise<void> {
    await api.delete(`/propostas/${id}`);
  }

  static async exportarPdf(id: number): Promise<void> {
    try {
      const data = (await api.get(`/propostas/${id}/pdf`, { responseType: 'blob' })) as Blob;
      const blob = data instanceof Blob ? data : new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `proposta_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success('PDF exportado com sucesso.');
    } catch (err: any) {
      toast.error(err.response?.data?.message || 'Erro ao exportar PDF.');
      throw err;
    }
  }
}
